// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b265bd48","453":"ab04c83b","732":"7e36ee6d","977":"ad3d6093"}[chunkId] + ".chunk.js";
};